import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", {
  id: "geneScatterPlot",
  class: "gene-scatter-plot"
}, null, -1)
const _hoisted_2 = { class: "statistics-container" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  id: "geneStatisticsPlot",
  class: "gene-statistics-plot"
}, null, -1)
const _hoisted_4 = { class: "statistics-content" }
const _hoisted_5 = { class: "statistics-content-p" }
const _hoisted_6 = { class: "statistics-content-p" }
const _hoisted_7 = { class: "statistics-content-p" }
const _hoisted_8 = { class: "statistics-content-p" }
const _hoisted_9 = { class: "statistics-content-p" }
const _hoisted_10 = { class: "statistics-content-p" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("p", _hoisted_5, "Count: " + _toDisplayString(_ctx.sCount), 1),
        _createElementVNode("p", _hoisted_6, "Mean: " + _toDisplayString(_ctx.sMean.toFixed(2)), 1),
        _createElementVNode("p", _hoisted_7, "Variance: " + _toDisplayString(_ctx.sVariance.toFixed(2)), 1),
        _createElementVNode("p", _hoisted_8, "Median: " + _toDisplayString(_ctx.sMedian.toFixed(2)), 1),
        _createElementVNode("p", _hoisted_9, "Max: " + _toDisplayString(_ctx.sMax.toFixed(2)), 1),
        _createElementVNode("p", _hoisted_10, "Min: " + _toDisplayString(_ctx.sMin.toFixed(2)), 1)
      ])
    ], 512), [
      [_vShow, _ctx.sExist]
    ]),
    _withDirectives(_createElementVNode("div", null, _toDisplayString(_ctx.sInfo), 513), [
      [_vShow, !_ctx.sExist]
    ])
  ], 64))
}